<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" @keydown.esc.stop="close">
            <v-card>
                <v-card-title class="text-h5 bg-grey-lighten-2">
                    <span class="text-h5">Create a Request</span>
                </v-card-title>
                <v-card-text class="mt-5">
                    <v-form class="" v-model="isFormValid" ref="form">
                        <v-autocomplete
                            v-model="selectedReqWorkflowType"
                            :items="reqWorkflowTypes"
                            item-title="name"
                            label="Select a Request Workflow type"
                            required
                        ></v-autocomplete>
                        <v-autocomplete
                            v-if="selectedReqWorkflowType"
                            v-model="selectedProtocol"
                            return-object
                            :items="filteredProtocols"
                            item-title="name"
                            label="Select a Protocol"
                            :rules="protocolRules"
                            required
                            searchable="false"
                        ></v-autocomplete>
                        <v-autocomplete
                            v-if="selectedProtocol"
                            v-model="selectedContainer"
                            :items="containerTypes"
                            item-title="name"
                            label="Select a Container type"
                            :rules="containerRules"
                            return-object
                            required
                            clearable
                        ></v-autocomplete>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" size="small" variant="text" @click="close">Cancel</v-btn>
                    <v-btn color="primary" :disabled="!isFormValid" @click="proceed" class="mr-3"
                        >Proceed</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { defineComponent } from "vue";

import _ from "lodash";
import { EventBus } from "@/lib/event-bus";
import { fetchContainerTypes } from "@/services/benchling/benchlingAPI";
import { requestsAPI } from "@/services/api.services";

export default defineComponent({
    name: "CreateRequestDialog",

    data() {
        return {
            dialog: true,
            containerTypes: [],
            protocols: [],
            reqWorkflowTypes: [
                "Molecular",
                "Analytical - HPLC",
                "Analytical - LCMS",
                "Analytical - Plate Reader",
                "Analytical - SDS-PAGE",
            ],
            selectedContainer: undefined,
            selectedProtocol: "",
            selectedReqWorkflowType: "",
            // Form validation
            isFormValid: false,
            containerRules: [(v) => (v ? true : "Container selection is required")],
            protocolRules: [(v) => (_.has(v, "registry_id") ? true : "Select a protocol")],
        };
    },

    computed: {
        filteredProtocols: function () {
            return this.protocols.filter(
                (protocol) => protocol.sample_workflow === this.selectedReqWorkflowType
            );
        },
    },

    created() {
        this.init();
    },

    methods: {
        async init() {
            try {
                this.protocols = await requestsAPI.fetchRequestProtocols();
                this.containerTypes = await fetchContainerTypes();
            } catch (err) {
                console.error(err);
                EventBus.$emit(
                    "message",
                    "Error loading dialog data. Please refresh your browser."
                );
            }
        },
        proceed() {
            // Emit selections to parent
            this.$emit("submit", {
                container: this.selectedContainer,
                protocols: [this.selectedProtocol],
                isSamplesBool: false,
            });
            this.dialog = false;
            this.$refs.form.reset();
        },
        close() {
            this.dialog = false;
            this.$refs.form.reset();
            window.history.back();
        },
    },

    watch: {
        selectedProtocol: function () {
            if (this.selectedProtocol) {
                const containerType = this.containerTypes.find(
                    (container) => container.id === this.selectedProtocol.container_type
                );
                this.selectedContainer = containerType;
            }
        },
    },
});
</script>

<style scoped></style>
